<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="my-page">
      <Title jpn="My page" />
      <div class="base_area">
        <div class="col">
          <GrayBack class="gray_area">
            <div class="name_area">
              <span>{{ lastName }} {{ firstName }}</span>
            </div>
          </GrayBack>
          <div class="address_change">
            <a href="https://minny-online-store.iranoan.com/contacts?service=1" target="_blank">Please contact us if you would like to change your address.</a>
          </div>
          <h4>Your points</h4>
          <h5>{{ point | comma }}P</h5>
          <div class="button_area">
            <SquareButton
              class="square-button"
              text="Buy points"
              @handleSquareBtnClick="goToPointBuy"
            />
          </div>
        </div>
        <div class="col">
          <div class="link_area">
            <GrayBack class="gray_area">
              <div class="link" @click="goToPointHistory">Your points history</div>
            </GrayBack>
            <GrayBack class="gray_area">
              <div class="link" @click="goToBuyProductHistory">Buying history</div>
            </GrayBack>
            <GrayBack class="gray_area">
              <div class="link" @click="goToUserGuide">User guide</div>
            </GrayBack>
            <GrayBack class="gray_area">
              <div class="link" @click="goContactUs">Contact us</div>
            </GrayBack>
            <GrayBack class="gray_area">
              <div class="link" @click="goToUserMenu">Setting registration information</div>
            </GrayBack>
          </div>
          <div class="button_area button_logout">
            <BlackGradationButton
              class="square-button"
              text="Logout"
              img="/img/logout_icon.png"
              @handleSquareBtnClick="logout"
            />
          </div>
        </div>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import ClickOutside from 'vue-click-outside';
import {
  separateCharacterNumber,
} from '@/common/util/format';

import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import GrayBack from '@/components/molecules/GrayBack.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import Title from '@/components/molecules/Title.vue';
import t from '@/plugins/i18n';

export default {
  name: 'MyPage',
  mixins: [t],

  components: {
    BaseTemplate,
    GrayBack,
    BlackGradationButton,
    SquareButton,
    Title,
  },

  directives: {
    ClickOutside,
  },

  filters: {
    comma(value) {
      return separateCharacterNumber(parseInt(value, 10));
    },
  },

  data: () => ({
    lastName: null,
    firstName: null,
    point: null,
  }),

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      currentUserDetail: 'user/currentUserDetail',
      currentAddress: 'zipCode/currentAddress',
      changeUserInformationResult: 'user/changeUserInformationResult',
      logOutUserResult: 'user/logOutUserResult',
    }),
  },

  watch: {
    currentUserDetail(newResult) {
      this.$nextTick(() => {
        this.lastName = newResult.lastName;
        this.firstName = newResult.firstName;
        this.point = newResult.availablePoint;
      });
    },
    logOutUserResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$store.dispatch('user/clearLogOutUserResult');
          this.$router.push('/login');
        }
      }
    },
  },

  created() {
    this.$store.dispatch('user/setCurrentUserDetail');
  },

  methods: {
    logout() {
      this.$store.dispatch('user/logOutUser');
    },
    goToUserMenu() {
      this.$router.push('./user-menu');
    },
    goToPointBuy() {
      this.$router.push('./buy-point');
    },
    goToBuyProductHistory() {
      this.$router.push('/buy-product-history');
    },
    goToPointHistory() {
      this.$router.push('./buy-point-history');
    },
    goToUserGuide() {
      this.$router.push('/user-guide');
    },
    goContactUs() {
      if (process.env.VUE_APP_LANG_MODE === 'jp') {
        window.open('https://minny-online-store.iranoan.com/contacts?service=1', '_blank');
      } else {
        window.open('https://minny-online-store.iranoan.com/contacts?service=1', '_blank');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.my-page{
  width: 100%;
  max-width: 800px;
  min-height: calc(100vh - 303px);
  padding-top: 30px;
  padding-bottom: 50px;
  margin: 0px auto;
  .address_change {
    margin-top: 5px;
  }
  .col {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
    width: 100%;
    padding: 12px;
  }
  .base_area {
    display: flex;
    .gray_area {
      width: 100%;
    }
    .name_area {
      color: $white;
      width: 100%;
      text-align: center;
      font-size: 24px;
    }
    h4 {
      margin: 40px 40px 10px 40px;
      background-color: $white;
      color: $deepColor;
      text-align: center;
      font-weight: normal;
    }
    h5 {
      text-align: center;
      color: $white;
      font-size: 36px;
    }
    .button_area {
      margin-top: 20px;
      .square-button {
        max-width: 300px;
        margin: auto;
      }
    }
    .link_area {
      .gray_area {
        padding: 10px 0;
        text-align: center;
        color: $white;
        margin: 5px 0;
        cursor: pointer;
        transition: .4s;
        &:nth-child(1) {
          margin-top: 0;
        }
        &:hover {
          background-color: $mainColor;
        }
      }
    }
    .button_logout {
      margin-top: 40px;
      .square-button {
        max-width: 200px;
      }
    }
  }
}
@media screen and (max-width: $tabletWidth) {
  .my-page{
    .base_area {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
